import { requestAndGetEODMessage } from '../../pusher/pusher.eod.observables';
import { closeEODShipmentsAsync } from '../shipments.api';
import { BehaviorSubject, EMPTY, merge, of, from } from 'rxjs';

import { catchError, filter, mergeMap } from 'rxjs/operators';
import { LogService } from '../../../services/log-service';
import { closeEODShipmentsFailure, closeEODShipmentsSuccess } from './shipments.eod.actions';
import { createTimeout } from '../../eod/timeout';

export const startCloseEODShipments = ({ action$, onError, onSuccess, payload }) => {
  const startCloseEODSubject = new BehaviorSubject(false);
  return startCloseEODSubject.pipe(
    mergeMap((isRetry) => {
      return requestAndGetEODMessage(() => from(closeEODShipmentsAsync(payload))).pipe(
        mergeMap(({ jobGuid, findMessage$ }) => {
          onSuccess(jobGuid);
          const timeout$ = createTimeout({
            action$,
            findMessage$,
            jobGuid,
            pusherTimeoutMs: 150000,
            isRetry,
            startCloseEODSubject,
            onCloseEODShipmentsFailure$: of(closeEODShipmentsFailure({ messageGuid: jobGuid })),
            logContext: {
              jobGuid,
            },
          });

          return merge(
            merge(findMessage$, timeout$.pipe(filter((next) => next?.pusherData))).pipe(
              mergeMap((response) => {
                const { pusherData, messageGuid } = response;
                LogService.logInfo('EOD Shipments closed', { pusherData });
                if (pusherData) {
                  const mappedPusherData = {
                    carrierId: pusherData.CarrierId,
                    errors: pusherData.Errors,
                    forms: pusherData.Forms,
                  };
                  return of(
                    closeEODShipmentsSuccess({
                      pusherData: mappedPusherData,
                      messageGuid,
                    }),
                  );
                }
                return EMPTY;
              }),
            ),
            timeout$.pipe(filter((next) => next?.type)),
          );
        }),
        catchError((error) => {
          LogService.logError(new Error('Error closing EOD shipments', { cause: error }));
          onError();
          return of(closeEODShipmentsFailure({}));
        }),
      );
    }),
  );
};
